export default __webpack_public_path__ + "static/media/404.bee0c48c.jpg";